

























































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { DataApi } from './models/Add.model';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { fetchAdd } from './fetchAdd';

import { paramApiGenerarEncomienda } from './models/Add.model';

@Component({ components: { DatePicker } })
export default class AddGenerarEncomienda extends Vue {
  @Prop({ required: true, default: false }) show!: boolean;
  @Prop({ required: true, default: {} }) data!: DataApi;

  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;
  dialog: boolean = false;
  loading: boolean = false;
  disabledForm: boolean = false;
  disabledBtn: boolean = false;
  disabledFieldValue: boolean = true;
  activateChange: boolean = false;
  paramApi: paramApiGenerarEncomienda = {
    despanumero: 'Por Asignar',
    despafecha_envia: moment(),
    courrier: {
      configid: '',
      configvalor: '',
    },
    despaseguimiento: '',
    localidad: {
      locaid: '',
      locaname: '',
      locabaja: '',
    },
    tecnico: {
      tecnicoid: '',
      tecniconame: '',
      estado: '',
    },
    usuario: {
      id: '',
      nombre: '',
      rut: '',
    },
    despaobs: '',
    despacargo_sino: false,
    despacargo_valor: '',
    despafecha_recibe: '',
    despareceptor: '',
  };

  listApi: Record<string, any[]> = {
    tecnicos: [],
    localidades: [],
    courriers: [],
  };

  async mounted() {
    try {
      this.loading = true;
      this.loadingService.showLoading(null, 'addGenerarEncomienda');
      this.dialog = this.show;
      await Promise.all([this.getFilters(), this.getValues()]);
    } catch (error) {
      console.error('Error con el modal: ', error);
    } finally {
      this.loading = false;
      this.loadingService.hideLoading('addGenerarEncomienda');
    }
  }

  async getValues(): Promise<void> {
    const newEncomienda = {
      id_add: this.data.id,
      numero_despacho: this.data.numero_despacho,
      nombre_add: this.data.nombre_add,
    };

    try {
      const result = await fetchAdd({
        endpoint: 'get_encomienda',
        body: { ...newEncomienda },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
      }
      if (Object.keys(LISTA[0]).length === 0) return;

      const {
        despanumero,
        nombre_add,
        despafecha_envia,
        despacourrier,
        despaseguimiento,
        locaid,
        tecnicoid,
        usuarioid_alta,
        usuariorut_alta,
        nombre,
        despaobs,
        despacargo_sino,
        despacargo_valor,
        despafecha_recibe,
        despareceptor,
      } = LISTA[0];

      // Valores iniciales
      this.paramApi.despanumero = despanumero;
      this.paramApi.despafecha_envia = moment(despafecha_envia);
      this.paramApi.courrier.configid = despacourrier;
      this.paramApi.despaseguimiento = despaseguimiento;
      this.paramApi.localidad.locaid = locaid;
      this.paramApi.tecnico.tecnicoid = tecnicoid;
      this.paramApi.usuario.id = usuarioid_alta;
      this.paramApi.usuario.rut = usuariorut_alta;
      this.paramApi.usuario.nombre = nombre;
      this.paramApi.despaobs = despaobs;
      const valDespacargo = Number(despacargo_sino) === 1 ? true : false;
      this.paramApi.despacargo_sino = valDespacargo;
      this.paramApi.despacargo_valor = despacargo_valor;
      this.paramApi.despafecha_recibe = despafecha_recibe
        ? moment(despafecha_recibe)
        : '';
      this.paramApi.despareceptor = despareceptor;
      this.disabledForm = true;
      this.$snotify.warning(
        `Ya se ha realizado una encomienda anteriormente en la asignación ${this.data.nombre_add}. Puede validar el detalle en el módulo "Encomiendas".`,
        { timeout: 3500 }
      );
    } catch (error) {
      console.error('Error iniciando los valores: ', error);
    }
  }

  async getFilters(): Promise<void> {
    try {
      const userId = JSON.parse(
        window.localStorage.getItem('user').replace(/'/g, '"')
      ).id;

      const result = await fetchAdd({
        serviceClient: 'conectaDespacho',
        endpoint: 'getFilter',
        body: { user_id: userId },
      });
      const {
        CODIGO_RESPUESTA,
        MENSAJE_RESPUESTA,
        TECNICO,
        LOCALIDAD,
        CURRIER,
        USER,
      } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }

      // Valores de los filtros
      this.listApi.tecnicos = TECNICO.filter(
        (tecnico: any) => tecnico.estado != '1'
      );
      this.listApi.localidades = LOCALIDAD.filter(
        (localidad: any) =>
          localidad.locabaja !== 't' &&
          !localidad.locaname
            .trim()
            .toLowerCase()
            .includes('santiago')
      );
      this.listApi.courriers = CURRIER;

      // Valores inciiales
      this.paramApi.usuario = USER[0];

      const findTecnico = TECNICO.find(
        (tecnico: any) => tecnico.tecnicoid === this.data.tecnicoid
      );

      if (findTecnico) {
        this.paramApi.tecnico = findTecnico;
      } else {
        this.$snotify.error(
          `El técnico ${this.data.nombre_tecnico} no se encuentra asignado en el mantenedor de técnicos`,
          { timeout: 3000 }
        );
        this.disabledBtn = true;
      }
    } catch (err) {
      console.error('Error: ', err);
    }
  }

  handleChange(): void {
    if (this.activateChange) {
      const despaseguimiento = this.paramApi.despaseguimiento
        ? this.paramApi.despaseguimiento.trim()
        : '';
      this.disabledBtn =
        despaseguimiento &&
        this.paramApi.localidad.locaid &&
        this.paramApi.tecnico.tecnicoid
          ? false
          : true;
    }
  }

  handleValor(): void {
    if (!this.paramApi.despacargo_sino) {
      this.disabledFieldValue = true;
      this.paramApi.despacargo_valor = '';
      return;
    }
    this.disabledFieldValue = false;
  }

  handleFormatValue(): void {
    const validateLengthPrice = this.paramApi.despacargo_valor.replace(
      /\./g,
      ''
    );

    // Verificar si hay más de 10 caracteres (sin contar los puntos)
    if (validateLengthPrice.length > 10) {
      this.paramApi.despacargo_valor = '';
      this.$snotify.error(
        'El campo valor solo permite como máximo 10 caracteres más un punto',
        { timeout: 3000 }
      );
      return;
    }

    const precio = this.paramApi.despacargo_valor;

    // Verificar si hay 11 caracteres y agregar un punto después del décimo si no hay
    if (precio.length === 10 && !precio.includes('.')) {
      this.paramApi.despacargo_valor =
        precio.substring(0, 8) + '.' + precio.substring(8);
      return;
    }
    // Verificar la cantidad de dígitos después del punto decimal
    const decimales = precio.split('.')[1];
    if (decimales && decimales.length > 2) {
      // Si hay más de dos dígitos después del punto, ajustar a dos decimales
      this.paramApi.despacargo_valor = precio.substring(
        0,
        precio.indexOf('.') + 3
      );
      return;
    }
    // Verificar si hay un punto y, si no lo hay, agregar punto y dos ceros al final
    if (!precio.includes('.')) {
      this.paramApi.despacargo_valor = precio + '.00';
      return;
    }
  }

  handleSubmit(): void {
    const despaseguimiento = this.paramApi.despaseguimiento
      ? this.paramApi.despaseguimiento.trim()
      : '';
    if (
      !despaseguimiento ||
      !this.paramApi.localidad.locaid ||
      !this.paramApi.tecnico.tecnicoid
    ) {
      this.$snotify.error(
        'Debe llenar todos los datos marcados como obligatorios',
        { timeout: 3000 }
      );
      this.activateChange = true;
      this.disabledBtn = true;
      return;
    }
    if (this.paramApi.despaobs && this.paramApi.despaobs.length > 500) {
      this.$snotify.error(
        'El campo observaciones solo permite un máximo de 100 caracteres',
        { timeout: 3000 }
      );
      return;
    }
    if (
      this.paramApi.despacargo_valor &&
      this.paramApi.despacargo_valor.length > 11
    ) {
      this.$snotify.error(
        'El campo valor solo permite como máximo 10 caracteres más un punto',
        { timeout: 3000 }
      );
      return;
    }
    this.insert();
  }

  rules: Record<string, Object> = {
    observacion: (val: string) =>
      val && val.length > 100
        ? 'Solo se permite como máximo 100 caracteres'
        : true,
    seguimiento: (val: any) =>
      !val || !val.trim() ? '* El orden de seguimiento es requerido' : true,
    localidad: (val: any) =>
      !val.locaid || !val.locaname ? '* La localidad es requerida' : true,
    precio: (val: any) =>
      val && val.length > 11
        ? 'Solo se permite como máximo 10 caracteres más un punto'
        : true,
  };

  handleClosed({ reload = false }: { reload?: boolean }): void {
    this.dialog = false;
    this.$emit('cerrar', reload);
  }

  async insert(): Promise<void> {
    const newEncomienda = {
      nombre_add: this.data.nombre_add,
      ...this.paramApi,
    };

    try {
      this.loadingService.showLoading(null, 'insert');
      const result = await fetchAdd({
        endpoint: 'insert_encomienda',
        body: { ...newEncomienda },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      this.handleClosed({ reload: true });
      this.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
    } catch (err) {
      this.$snotify.error('Ocurrió un error inesperado, por favaor reintente', {
        timeout: 3000,
      });
      console.error('Error: ', err);
    } finally {
      this.loadingService.hideLoading('insert');
    }
  }
}
